import type * as lazyIndex from './lazyIndex';
import { LazyImport, LazyModule } from 'owa-bundling';
import type EditorViewState from './store/schema/EditorViewState';

export type { default as PluginWithViewState } from './store/schema/PluginWithViewState';
export type { default as PluginWithUI } from './store/schema/PluginWithUI';

export type { default as ContentModelPluginWithViewState } from './store/schema/ContentModelPluginWithViewState';
export type { default as ContentModelPluginWithUI } from './store/schema/ContentModelPluginWithUI';

export type { OperateContentType } from './utils/operateContent';
export { getEditorScenarioFromEditorId } from './utils/getEditorScenarioFromEditorId';
const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(
    () => import(/* webpackChunkName: "HtmlEditor" */ './lazyIndex'),
    { name: 'HtmlEditor' }
);

export type { TextDirection } from './store/schema/TextDirection';
export const lazyOperateContent: LazyImport<typeof lazyIndex.operateContent, typeof lazyModule> =
    new LazyImport(lazyModule, m => m.operateContent);
export type { default as PluginViewStateAdapter } from './store/schema/PluginViewStateAdapter';
export type { default as EditorViewState } from './store/schema/EditorViewState';

const lazyFocusToEditor: LazyImport<typeof lazyIndex.focusToEditor, typeof lazyModule> =
    new LazyImport(lazyModule, m => m.focusToEditor);
export function focusToEditor(viewState: EditorViewState): void {
    lazyFocusToEditor.import().then(focusEditor => focusEditor(viewState));
}

export { getRawComposeFormat } from './utils/getRawComposeFormat';
export { callEditorApi } from './utils/callEditorApi';
